import $ from "jquery"
import u from "umbrellajs"

import SaveManager from "concepts/listings/searches/saved/manager"

import {EventEmitter} from "events"

interface Selector {
  scope:                string | UmbrellaInstance
  main:                 string | UmbrellaInstance

  save_button:          string | UmbrellaInstance
}
interface InputSelector {
  scope?:               string | UmbrellaInstance
  main?:                string | UmbrellaInstance

  save_button?:         string | UmbrellaInstance
}
const DEFAULT_SELECTOR = {
  scope:              ".page-cities-search-for-sale",
  main:               ".page--shared--mobile-ver-pages--save-and-share-search-banner",

  save_button:        ".page--shared--mobile-ver-pages--save-and-share-search-banner-button",
}

const DISMISSED_CLASS = "page--shared--mobile-ver-pages--save-and-share-search-banner--dismissed"
const HIDE_CLASS = "page--shared--mobile-ver-pages--save-and-share-search-banner--hide"
const SAVED_CLASS = "page--shared--mobile-ver-pages--save-and-share-search-banner--saved"

class SaveSearchContainer extends EventEmitter {
  protected selector: Selector

  protected $scope:       UmbrellaInstance
  protected $el:          UmbrellaInstance
  protected $save_button: UmbrellaInstance

  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$scope = u(this.selector.scope)
    this.$el = this.$scope.find(this.selector.main)
    this.$save_button = this.$el.find(this.selector.save_button)

    this.bind_action()
  }

  public dismiss(){
    this.$el.addClass(HIDE_CLASS)
    this.$el.addClass(DISMISSED_CLASS)
  }

  public show(){
    this.$el.removeClass(SAVED_CLASS)
    this.$el.removeClass(DISMISSED_CLASS)
    this.$el.removeClass(HIDE_CLASS)
  }

  protected set_save_button_loading(){
    this.$save_button.addClass("loading")
  }

  protected set_save_button_idle(){
    this.$save_button.removeClass("loading")
  }

  protected bind_action(){
    SaveManager.on("save_click:action", () => {
      this.set_save_button_loading()
    })

    SaveManager.on("save_click:idle", () => {
      this.set_save_button_idle()
    })

    SaveManager.on("save_click:success", () => {
      this.set_save_button_idle()
      this.$el.addClass(SAVED_CLASS)
    })

    let last_scroll_top = 0

    $(window).scroll(() => {
      if (this.$el.hasClass(DISMISSED_CLASS)){
        return
      }

      const current_scroll_top = $(window).scrollTop() || 0

      if (current_scroll_top > 46 && (current_scroll_top > last_scroll_top)){
        this.$el.addClass(HIDE_CLASS)
      }else{
        this.$el.removeClass(HIDE_CLASS)
      }

      last_scroll_top = current_scroll_top
    })

  }
}

const Factory = {
  _instance: null as null | SaveSearchContainer,
  instance(selector?: InputSelector){
    if (this._instance != null) { return this._instance }

    this._instance = this.create(selector)
    return this._instance
  },
  create(selector?: InputSelector){
    return new SaveSearchContainer(selector)
  },
}

export {
  Factory,
  SaveSearchContainer,
}
